module.exports = __webpack_public_path__ + "static/citrix-83aae50261b754aaad55af0c330d97d3.png";